import { TrackedAnchor } from '@/components/ancher';
import { LINKS } from '@/constants';
import { cn } from '@lib/utils';
import Image, { StaticImageData } from 'next/image';

interface IconCardButtonProps {
  className?: string;
  iconClassName: string;
  title: string;
  icon: StaticImageData;
}

function IconCardButton({
  className,
  iconClassName,
  title,
  icon,
}: IconCardButtonProps) {
  return (
    <TrackedAnchor
      label="gene_list"
      position="main_content"
      href={LINKS.GENE_BROWSER}
      className={cn(
        'flex size-[100px] flex-shrink-0 cursor-pointer flex-col items-center gap-1 rounded-xl px-4 pb-4 pt-5 hover:bg-3b-other-neutral-darkAlpha-300',
        className,
      )}
    >
      <div
        className={cn(
          'flex aspect-square size-[36px] items-center justify-center rounded-full bg-3b-blue-light-400',
          iconClassName,
        )}
      >
        <Image src={icon} alt="icon" width={26.5} height={26.795} />
      </div>
      <span className="text-center text-body1 font-semibold leading-[26px] text-white">
        {title}
      </span>
    </TrackedAnchor>
  );
}

export default IconCardButton;
